export default __webpack_public_path__ + "static/media/backgroundmobile.cd345f83.png";